import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M9 7l5-5 5 5M14 2v12M5 17l5 5 5-5M10 22V10" stroke={color} strokeWidth="2" />
  </svg>
);
